

















































import VueOptions from '@utils/VueOptions'
import LoadingIndicator from '@/components/LoadingIndicator'
import Modal from '@/components/Modal'
import RequestButton from '@/components/RequestButton'
import SetOfferBankingContactTrigger from './SetOfferBankingContactTrigger.coffee'

settings =
  name: 'SetOfferBankingContactTriggerModal'

  resources:
    banking_contacts:
      resourceName: 'banking_contacts'
      slug: 'offers/:offer.id/banking_contacts'
      fetch: false

  vue:
    props: ['resourceComponent', 'resourceKey']
    mixins: [SetOfferBankingContactTrigger.trigger()]

    components: {
      LoadingIndicator,
      Modal,
      RequestButton,
    }

    data: ->
      selectedIndex: -1
      newBankingContact:
        email: null
        level: null

    computed:
      modalConfig: -> @modal.config || {}
      offer: -> @modalConfig.offer
      audienceListing: -> @ctxAudienceListing @offer
      subOrg: -> @ctxSupplierSubOrg @offer
      topOrg: -> @ctxSupplierOrg @offer

      optionsForLevelSelect: ->
        @compact([
          { value: 'venue', label: 'Venue' } if @audienceListing.id
          { value: 'audience_creative', label: 'Experience' } if @audienceListing.id
          { value: 'team', label: 'Team' } if @audienceListing.id
          { value: 'top_org', label: 'Org' }
        ])

    methods:
      onLoadCollectionCompleted: (resourceKey) ->
        return unless resourceKey is 'banking_contacts'
        bankingContact = @offer.ctx.banking_contact || {}
        @selectedIndex = @banking_contacts.findIndex((item) => item.email is bankingContact.email and item.level is bankingContact.level)
        @resetModalPayload()

      resetModalPayload: ->
        bankingContact = { ...@banking_contacts[@selectedIndex] } if @selectedIndex >= 0
        bankingContact = @newBankingContact if @selectedIndex is 'new'
        @modal.data.banking_contact = bankingContact

      formatLabel: (bankingContact) ->
        level = @formatLevel(bankingContact.level).toUpperCase()
        label = @formatName(bankingContact.level)
        [level, label].filter(Boolean).join(': ')

      formatLevel: (level) ->
        str = @optionsForLevelSelect.find((item) => item.value is level)?.label
        str ||= @$options.filters.formatTitle(level)

      formatName: (level) ->
        switch level
          when 'venue' then [@audienceListing.venue_name, @$options.filters.formatLocation(@audienceListing)].join(' - ')
          when 'audience_creative' then @audienceListing.creative_title
          when 'team' then @subOrg.name
          when 'top_org' then @topOrg.name

    watch:
      selectedIndex: ->
        @resetModalPayload()

export default VueOptions.vue settings
